import { useEffect, useState } from "react";
import { AppBar, Tab, Tabs } from "@material-ui/core";
import { useIntl } from "react-intl";
import { Outlet, useNavigate} from "react-router-dom";
import { useStyles } from "./DocumentGroup.style";
const AdministrationTabs = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const tabEnum = {
    user: 0,
    "permission-group": 1,
    folder: 2,
    documents: 3,
    archive:4,
    0: "user",
    1: "permission-group",
    2: "folder",
    3: "documents",
    4:"archive",
  };
  useEffect(() => {
    setTab(tabEnum[window.location.pathname.split("/")[3]]);
  }, []);
  const handleChange = (event, newValue) => {
    setTab(newValue);
    switch (newValue) {
      case 0:
        navigate("/ms/administrations/user");
        break;
      case 1:
        navigate("/ms/administrations/permission-group");
        break;
      case 2:
        navigate("/ms/administrations/folder");
        break;
      case 3:
        navigate("/ms/administrations/documents");
        break;
        case 4:
          navigate("/ms/administrations/archive");
          break;
      default:
        navigate("/ms/administrations/documents");
    }
  };
  return (
    <div className="adminitration-tabs">
      <AppBar className={classes.tabs} position="static">
        <Tabs
          value={tab}
          onChange={handleChange}
          indicatorColor="primary"
          aria-label="nav tabs example"
          
        >
          <Tab
            label={formatMessage({ id: "form.user", defaultMessage: "User" })}
          />
          <Tab
            label={formatMessage({
              id: "header.title.user-group",
              defaultMessage: "Permission Groups",
            })}
          />
          <Tab
            label={formatMessage({
              id: "tab.folder",
              defaultMessage: "Folders",
            })}
          />
          <Tab
            label={formatMessage({
              id: "component.sidebar.document",
              defaultMessage: "Document",
            })}
          />
          <Tab
            label={formatMessage({
              id: "component.sidebar.archive",
              defaultMessage: "Archive",
            })}
          />
        </Tabs>
      </AppBar>
      <Outlet />
    </div>
  );
};
export default AdministrationTabs;
